module.exports = __webpack_public_path__ + "img/bg01.e35ac82d.png";